import { defineSseEvent } from '@terra/shared-sse-contracts';
import { TargetTypeSchema } from '@terra/shared-schemas-orchestrator';
import { z } from 'zod';

export const BATCH_URL_PARAMETRIZATION_STARTED_SSE_TYPE =
  'BATCH_URL_PARAMETRIZATION_STARTED' as const;
export const BATCH_URL_PARAMETRIZATION_COMPLETED_SSE_TYPE =
  'BATCH_URL_PARAMETRIZATION_COMPLETED' as const;
export const BATCH_URL_PARAMETRIZATION_FAILED_SSE_TYPE =
  'BATCH_URL_PARAMETRIZATION_FAILED' as const;
export const BATCH_URL_PARAMETRIZATION_ASSETS_UPDATED_SSE_TYPE =
  'BATCH_URL_PARAMETRIZATION_ASSETS_UPDATED' as const;

export const BatchUrlParametrizationSsePayloadSchema = z.object({
  applicationId: z.string(),
  targetId: z.string(),
  targetType: TargetTypeSchema,
});

export const BATCH_URL_PARAMETRIZATION_STARTED_SSE_EVENT = defineSseEvent({
  type: BATCH_URL_PARAMETRIZATION_STARTED_SSE_TYPE,
  payload: BatchUrlParametrizationSsePayloadSchema,
  channelPrefix: 'batch-url-parametrization',
  channelKey: ({ applicationId }) => applicationId,
  target: {
    type: (payload) => payload.targetType,
    id: (payload) => payload.targetId,
  },
});

export const BATCH_URL_PARAMETRIZATION_COMPLETED_SSE_EVENT = defineSseEvent({
  type: BATCH_URL_PARAMETRIZATION_COMPLETED_SSE_TYPE,
  payload: BatchUrlParametrizationSsePayloadSchema,
  channelPrefix: 'batch-url-parametrization',
  channelKey: ({ applicationId }) => applicationId,
  target: {
    type: (payload) => payload.targetType,
    id: (payload) => payload.targetId,
  },
});

export const BATCH_URL_PARAMETRIZATION_FAILED_SSE_EVENT = defineSseEvent({
  type: BATCH_URL_PARAMETRIZATION_FAILED_SSE_TYPE,
  payload: BatchUrlParametrizationSsePayloadSchema,
  channelPrefix: 'batch-url-parametrization',
  channelKey: ({ applicationId }) => applicationId,
  target: {
    type: (payload) => payload.targetType,
    id: (payload) => payload.targetId,
  },
});

export const BATCH_URL_PARAMETRIZATION_ASSETS_UPDATED_SSE_EVENT = defineSseEvent(
  {
    type: BATCH_URL_PARAMETRIZATION_ASSETS_UPDATED_SSE_TYPE,
    payload: BatchUrlParametrizationSsePayloadSchema,
    channelPrefix: 'batch-url-parametrization',
    channelKey: ({ applicationId }) => applicationId,
    target: {
      type: (payload) => payload.targetType,
      id: (payload) => payload.targetId,
    },
  },
);

export const BATCH_WEBPAGE_PARAMETRIZATION_STARTED_SSE_TYPE =
  'BATCH_WEBPAGE_PARAMETRIZATION_STARTED' as const;
export const BATCH_WEBPAGE_PARAMETRIZATION_COMPLETED_SSE_TYPE =
  'BATCH_WEBPAGE_PARAMETRIZATION_COMPLETED' as const;
export const BATCH_WEBPAGE_PARAMETRIZATION_FAILED_SSE_TYPE =
  'BATCH_WEBPAGE_PARAMETRIZATION_FAILED' as const;

export const BatchWebpageParametrizationSsePayloadSchema =
  BatchUrlParametrizationSsePayloadSchema;

export const BATCH_WEBPAGE_PARAMETRIZATION_STARTED_SSE_EVENT = defineSseEvent({
  type: BATCH_WEBPAGE_PARAMETRIZATION_STARTED_SSE_TYPE,
  payload: BatchWebpageParametrizationSsePayloadSchema,
  channelPrefix: 'batch-webpage-parametrization',
  channelKey: ({ applicationId }) => applicationId,
  target: {
    type: (payload) => payload.targetType,
    id: (payload) => payload.targetId,
  },
});

export const BATCH_WEBPAGE_PARAMETRIZATION_COMPLETED_SSE_EVENT = defineSseEvent({
  type: BATCH_WEBPAGE_PARAMETRIZATION_COMPLETED_SSE_TYPE,
  payload: BatchWebpageParametrizationSsePayloadSchema,
  channelPrefix: 'batch-webpage-parametrization',
  channelKey: ({ applicationId }) => applicationId,
  target: {
    type: (payload) => payload.targetType,
    id: (payload) => payload.targetId,
  },
});

export const BATCH_WEBPAGE_PARAMETRIZATION_FAILED_SSE_EVENT = defineSseEvent({
  type: BATCH_WEBPAGE_PARAMETRIZATION_FAILED_SSE_TYPE,
  payload: BatchWebpageParametrizationSsePayloadSchema,
  channelPrefix: 'batch-webpage-parametrization',
  channelKey: ({ applicationId }) => applicationId,
  target: {
    type: (payload) => payload.targetType,
    id: (payload) => payload.targetId,
  },
});

export type BatchUrlParametrizationSsePayload = z.infer<
  typeof BatchUrlParametrizationSsePayloadSchema
>;

export type BatchWebpageParametrizationSsePayload = z.infer<
  typeof BatchWebpageParametrizationSsePayloadSchema
>;
